import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, CustomInput, Button } from 'reactstrap';
import Loader from 'react-loaders';
import { api } from '../../_services/api.service';
import {  userService } from '../../_services/user.service';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import {
    toast
} from 'react-toastify';
import swal from 'sweetalert';
import Compressor from 'compressorjs';

const Profile = (props) => {

    const currentUser = userService.getLoggedInUser();
    const hiddenFileInput = React.useRef(null);

    let [user, setUser] = useState(null);
    let [isLoading, setIsLoading] = useState(false);

    const successToastOpts = {
        autoClose: 3000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: false
    };

    useEffect(() => {
        setUser(currentUser);
        loadAvatar();
    }, [])

    const loadAvatar = () => {
        api.getUserPhotoBase64(currentUser.userId).then(uri => {
            setUser({ ...currentUser, imageUri: uri });
        })
    }

    const handleSubmit = (e, errors, values) => {
        if (errors.length == 0) {
            api.updateUser(currentUser.userId, user).then(data => {
                toast("User updated successfuly", successToastOpts);
                api.getUserById(currentUser.userId).then(updatedUser => {
                    updatedUser.userId = updatedUser.userID;
                    updatedUser.roleId = updatedUser.roleID;
                    updatedUser.partnerId = updatedUser.partnerID;
                    updatedUser.password = "";
                    userService.updateUser(updatedUser);
                    setUser(updatedUser);
                })
            })
            // if (participant.participantID > 0) {

            //     api.updateParticipant(currentUser.userID, participant).then(data => {
            //         toast("Participant saved successfuly", successToastOpts);
            //         //props.history.goBack();
            //     })
            // } else {
            //     let obj = { ...participant };
            //     obj.user = {};
            //     obj.user.firstName = participant.firstName;
            //     obj.user.lastName = participant.lastName;
            //     obj.user.email = participant.email;
            //     api.createParticipant(currentUser.userID, partnerScenarioId, obj).then(id => {
            //         toast("Participant saved successfuly", successToastOpts);

            //         //props.history.goBack();
            //         props.history.replace({
            //             pathname: `/participant/${partnerId}/${partnerScenarioId}/${id}`
            //         });
            //         // partnerMetricId = id;
            //         // loadMetric(id);
            //     })
            // }
        }
    }

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    const handleChange = event => {
        const fileUploaded = event.target.files[0];
        new Compressor(fileUploaded, {
            quality: 0.5,
            maxWidth: 200, // Set max width to resize
            maxHeight: 200, // Set max height to resize
            success: (resizedImage) => {
              const reader = new FileReader();
              reader.readAsDataURL(resizedImage);
              reader.onloadend = async () => {
                setUser({ ...user, imageUri: reader.result.split(',')[1] });
                api.updateUserPhotoBase64(user.userId, reader.result.split(',')[1]).then(r => {
                    window.location.reload(false);
                });
              };
            },
          });
       
    };

    const getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    return (
        <Fragment>
            {isLoading && <Loader style={{}} type="ball-pulse" active />}
            {!isLoading && user !== null &&
                <Row style={{ marginTop: '30px' }}>
                    <Col md="6">
                        <Card className="main-card mb-3">
                            <CardBody>
                                <div style={{ textAlign: 'center' }}>
                                    {user.imageUri !== undefined && user.imageUri !== '' &&
                                        <img width={100} height={100}
                                            className="rounded-circle"
                                            src={user.imageUri.indexOf('base64') > -1 ? user.imageUri : `data:image/jpeg;base64,${user.imageUri}`}
                                            alt="avatar"
                                            onClick={handleClick}
                                        />
                                    }
                                    {(user.imageUri == undefined || user.imageUri == '') &&
                                        <div style={{
                                            width: 100,
                                            height: 100,
                                            margin: 'auto',
                                            borderRadius: 50,
                                            borderWidth: 1,
                                            borderColor: 'white',
                                            borderStyle: 'solid',
                                            backgroundColor: '#428AF8',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }} onClick={handleClick}>
                                            <div style={{ fontSize: 20, textAlign: 'center', color: 'white' }}>{currentUser.firstName.charAt(0) + currentUser.lastName.charAt(0)}</div>
                                        </div>
                                    }
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={hiddenFileInput}
                                    onChange={handleChange}
                                    style={{ display: 'none' }}
                                />
                                <AvForm onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="12">
                                            <AvField name="firstName" label="First Name *" value={user.firstName}
                                                onChange={(e) => setUser({ ...user, firstName: e.target.value })} placeholder="Enter..." required />
                                            <AvField name="lastName" label="Last Name *" value={user.lastName}
                                                onChange={(e) => setUser({ ...user, lastName: e.target.value })} placeholder="Enter..." required />
                                            <AvField name="email" label="Email *" value={user.email}
                                                onChange={(e) => setUser({ ...user, email: e.target.value })} placeholder="Enter..." required />
                                            <AvField name="password" label="Password " value={user.password} type="password"
                                                onChange={(e) => setUser({ ...user, password: e.target.value })} placeholder="Enter..." />

                                        </Col>
                                    </Row>
                                    <div className="pull-right">
                                        <Button color='primary' type="submit" style={{ marginRight: '.25rem' }}>Save</Button>
                                        <Button color='link' className="pull-right" onClick={() => props.history.goBack()}>Cancel</Button>
                                    </div>
                                </AvForm>


                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
        </Fragment >
    )
}

export default Profile;